var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9836 9.25C12.3302 9.25 8.58253 11.3645 5.63221 15.5936C5.548 15.7156 5.50185 15.8599 5.4996 16.0082C5.49735 16.1564 5.53909 16.302 5.61956 16.4266C7.88643 19.975 11.5839 22.75 15.9836 22.75C20.3355 22.75 24.1089 19.9666 26.38 16.4102C26.4586 16.2881 26.5004 16.1459 26.5004 16.0007C26.5004 15.8555 26.4586 15.7134 26.38 15.5912C24.1038 12.0756 20.3027 9.25 15.9836 9.25Z",
    stroke: "#1C1C1F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9995 19.75C18.0706 19.75 19.7495 18.0711 19.7495 16C19.7495 13.9289 18.0706 12.25 15.9995 12.25C13.9284 12.25 12.2495 13.9289 12.2495 16C12.2495 18.0711 13.9284 19.75 15.9995 19.75Z",
    stroke: "#1C1C1F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEye);
export default __webpack_public_path__ + "static/media/open-eye.76d2741a6beaf7fcc41971d07ab0c48f.svg";
export { ForwardRef as ReactComponent };